import { useQueryClient } from '@tanstack/react-query';
import { apiPost } from '@/lib/api';
import { pricebookKeys } from '@/lib/queryKeys';
import { useApiMutation } from '../useApiMutation';
import { usePricebookApi } from './usePricebookApi';
import { ITEM_TYPE_TO_BACKEND } from '@/types/pricebook';
import type { ImportItemsDto, ImportItemsResponse } from '@/types/pricebook';

export function useImportItems() {
  const queryClient = useQueryClient();
  const { client, ep } = usePricebookApi();

  return useApiMutation<ImportItemsResponse, ImportItemsDto>({
    mutationFn: (dto) => {
      const payload = {
        items: dto.items.map((item) => ({
          ...item,
          type: ITEM_TYPE_TO_BACKEND[item.type] ?? item.type,
        })),
      };
      return apiPost<ImportItemsResponse>(client, ep.import(), payload);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: pricebookKeys.lists() });
    },
    showErrorToast: false,
  });
}
